export const CONTACTS = "contacts";
export const TEMPLATES = "templates";
export const INBOUND_MESSAGES = "inbound";
export const OUTBOUND_MESSAGES = "outbound";
export const CONVERSATIONS = "conversations";
export const BOT_RESPONSE = "bot_response"
